module.exports = __webpack_public_path__ + "static/stairsVision-1-c1d2591db55e19fd24d5369a413d9e85.png";